import { serverAxios } from '@/shared/api';
import { ArticleResponseItem } from '@/shared/types';

export const representativeArticleListApi = () => {
  return serverAxios.get<ArticleResponseItem[]>('/yozmit/news-representative/');
};
